/* eslint-disable class-methods-use-this */
import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 外壁厚の設定
 */
export default class OuterWallThicknessSettingDialog extends Dialog {
    targetFitting: marietta.webcad.item.Fitting;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);
      // ターゲットのアイテム
      this.targetFitting = marietta.webcad.WebCADGlobal.itemManager.currentItem as marietta.webcad.item.Fitting;

      // ダイアログのコンテンツ生成
      const id = 'outerWallThicknessSettingDialog';
      let title = '外壁厚の設定';

      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Outerwall Thickness Setting'; break;
        default: title = '外壁厚の設定'; break;
      }

      let contents = '<div class="dialogOuterWallThicknessSetting">\n';
      contents += '<table id="outerWallThicknessSettingGroup">\n';
      contents += '<tbody>\n';
      contents += '<tr>\n';
      contents += '<th>\n<label for="selectOuterWallThickness"><span class="jp">厚さ</span><span class="en">Thickness</span></label></th>\n';
      contents += '<td>';
      contents += '<select id="selectOuterWallThickness" name="selectOuterWallThickness">';
      const thichnessList = marietta.webcad.WebCADGlobal.outerWallThicknessList;
      for (let i = 0; i < thichnessList.length; i += 1) {
        contents += `<option value="${thichnessList[i]}">${thichnessList[i]}</option>`;
      }
      contents += '</td>\n';
      contents += '</tr>\n';
      contents += '</tbody>\n';
      contents += '</table>\n';
      contents += '</div>';

      let footer = '<button id="btnDoneOuterWallThicknessSetting"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
      footer += '<button id="btnCancelOuterWallThicknessSetting"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';

      this.createDialog(id, title, contents, footer);

      this.initMe();

      // イベント設定
      let btn = document.querySelector('#btnDoneOuterWallThicknessSetting');
      if (btn) {
        btn.addEventListener('click', this.updateThickness);
      }

      // イベント設定
      let cancelBtn = document.querySelector('#btnCancelOuterWallThicknessSetting');
      if (cancelBtn) {
        cancelBtn.addEventListener('click', this.close);
      }
      // お掃除
      title = '';
      contents = '';
      footer = '';
      btn = null;
      cancelBtn = null;
    }

    /**
     * ダイアログの初期設定
     */
    initMe() {
      (<HTMLSelectElement>document.querySelector('#selectOuterWallThickness')).value = marietta.webcad.WebCADGlobal.webcad2Dmanager.outerWallThickness.toString();
    }

    /**
     * 外壁厚の設定
     */
    updateThickness = () => {
      // 入力チェック
      const thickness = parseInt((<HTMLSelectElement>document.querySelector('#selectOuterWallThickness')).value, 10);
      marietta.webcad.WebCADGlobal.webcad2Dmanager.outerWallThickness = thickness;
      marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
      marietta.webcad.WebCADGlobal.updateMeasureLine(false, false);
      // ダイアログを閉じる
      this.close();
    }
}
